import React from 'react';
import { ChevronLeft, ChevronRight, ZoomIn } from 'lucide-react';

const AnalysisImageGallery = ({
  analysisDisplayImageUrls,
  currentImageIndex,
  onChangeCurrentImageIndex,
  items,
  colors,
  onOpenModal,
  onMarkResultImageError,
}) => {
  return (
    <div className="w-full flex flex-col gap-3 sm:gap-4">
      <div
        className="relative aspect-video bg-slate-900 rounded overflow-hidden flex items-center justify-center group cursor-pointer"
        onClick={onOpenModal}
      >
        <div className="relative">
          <img
            src={analysisDisplayImageUrls[currentImageIndex]}
            alt="Analyzed"
            className="max-w-full max-h-full transition-all group-hover:brightness-90 block"
            onError={() => onMarkResultImageError(currentImageIndex)}
          />

          <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 flex items-center justify-center transition-all z-10 pointer-events-none">
            <div className="bg-surface p-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0">
              <ZoomIn size={20} className="text-brand" />
            </div>
          </div>

          {(items || []).map((item, idx) => {
            const colorClass = colors[idx % colors.length];
            const [borderColor, bgColor] = colorClass.split(' ');

            let currentBox = null;
            let currentLabel = item.item;
            if (item.bounding_boxes && Array.isArray(item.bounding_boxes)) {
              const bbEntry = item.bounding_boxes[currentImageIndex];
              if (bbEntry && typeof bbEntry === 'object' && bbEntry.box) {
                currentBox = bbEntry.box;
                currentLabel = bbEntry.label || currentLabel;
              } else {
                currentBox = bbEntry;
              }
            } else if (currentImageIndex === 0) {
              currentBox = item.bounding_box;
            }

            if (Array.isArray(currentBox) && currentBox.every((val) => val === 0)) {
              currentBox = null;
            }

            return currentBox && (
              <div
                key={`bb-${idx}`}
                className={`absolute border-2 ${borderColor} transition-all pointer-events-none`}
                style={{
                  top: `${currentBox[0] / 10}%`,
                  left: `${currentBox[1] / 10}%`,
                  height: `${(currentBox[2] - currentBox[0]) / 10}%`,
                  width: `${(currentBox[3] - currentBox[1]) / 10}%`,
                }}
              >
                <span className={`absolute -top-5 left-0 ${bgColor} text-white text-[8px] px-1 rounded whitespace-nowrap shadow-sm`}>
                  {currentLabel}
                </span>
              </div>
            );
          })}
        </div>

        {analysisDisplayImageUrls.length > 1 && (
          <>
            {currentImageIndex > 0 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onChangeCurrentImageIndex(currentImageIndex - 1);
                }}
                className="absolute left-2 top-1/2 -translate-y-1/2 z-50 p-1.5 bg-black/40 text-white rounded-full hover:bg-black/60 transition-all shadow-lg"
              >
                <ChevronLeft size={20} />
              </button>
            )}
            {currentImageIndex < analysisDisplayImageUrls.length - 1 && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onChangeCurrentImageIndex(currentImageIndex + 1);
                }}
                className="absolute right-2 top-1/2 -translate-y-1/2 z-50 p-1.5 bg-black/40 text-white rounded-full hover:bg-black/60 transition-all shadow-lg"
              >
                <ChevronRight size={20} />
              </button>
            )}
          </>
        )}
      </div>

      {analysisDisplayImageUrls.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-2">
          {analysisDisplayImageUrls.map((url, idx) => (
            <img
              key={idx}
              src={url}
              onClick={() => onChangeCurrentImageIndex(idx)}
              className={`w-16 h-16 object-cover rounded cursor-pointer transition-all border-2 ${currentImageIndex === idx ? 'border-brand scale-105 shadow-sm' : 'border-transparent opacity-60 hover:opacity-100'}`}
              alt={`Thumb ${idx}`}
              onError={() => onMarkResultImageError(idx)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AnalysisImageGallery;
